import { TransportHelper } from '@utils/transport.helper';
﻿import { updateState, withDevtools } from "@angular-architects/ngrx-toolkit";
import { inject } from "@angular/core";
import { AdditionalServiceDto } from "@dtos/additional-services.dto";
import { CertificationsDto } from "@dtos/certifications.dto";
import { BillingAccountItemDto, ClientBillingAccountDto } from "@dtos/clients/billingsAccounts.dto";
import { ClientAdditionalServiceDto } from "@dtos/clients/clientAdditional-services.dto";
import { ClientCertification } from "@dtos/clients/clientsCertifications.dto";
import { DocumentsClientsDto } from "@dtos/clients/documents.dto";
import { PriceRulesClientDto } from "@dtos/clients/priceRules.dtos";
import { ProtocolDto } from "@dtos/clients/protocols.dto";
import { ErrorBase } from "@dtos/errors.dtos";
import { ClientDto, TransportAddress } from "@dtos/index";
import { ClientBillingAccountEntity, DocumentTemplateTransportEntity } from "@entities/clients.entities";
import { patchState, signalStore, withComputed, withMethods, withState } from "@ngrx/signals";
import { ClientsProvider } from "@providers";
import { Helpers } from "@utils/helpers";
import { environment } from "src/environments/environment";

export class ClientsState {
    client: ClientDto = new ClientDto();
    documents: DocumentsClientsDto[] = [];
    protocols: ProtocolDto[] = [];
    priceRules: PriceRulesClientDto = new PriceRulesClientDto();
    billingsAccounts: BillingAccountItemDto[] = [];
    currentBillingAccount: ClientBillingAccountDto = new ClientBillingAccountDto();
    certifications: ClientCertification[] = [];
    certificationsTemplates: CertificationsDto[] = [];
    transportAddress: TransportAddress[] = [];
    curImage: File | null = null;
    currentDocument: DocumentsClientsDto = {} as DocumentsClientsDto;
    currentProtocol: ProtocolDto = new ProtocolDto();
    currentCertification: ClientCertification = new ClientCertification();
    additionalServicesTemplates: AdditionalServiceDto[] = [];
    additionalServices: ClientAdditionalServiceDto[] = [];
    currentAdditionalService: ClientAdditionalServiceDto = new ClientAdditionalServiceDto();
    errors: string[] = [];
  }



export const ClientStore = signalStore(
  { 
    providedIn: 'root',
    // ConfiguraciÃ³n para Redux DevTools
    ...(typeof window !== 'undefined' && (window as any).__REDUX_DEVTOOLS_EXTENSION__ && {
      devtools: {
        name: 'RoadIt Global Store',
        trace: true,
        traceLimit: 25
      }
    })
  },
  withDevtools('ClientStore'),
  // Estado inicial usando directamente GlobalStateData
  withState(new ClientsState()),
  withComputed( (store) => ({
    logoSrc: () => {
      var curImage:any = store.curImage();
      if(curImage instanceof File ){
        return URL.createObjectURL(curImage!);
      }
       if(store.client().logo && store.client().logo!.length > 0){
        let logo = store.client().logo!;
        if(!logo?.startsWith("http") && !logo?.startsWith("blob:")){
          return  environment.apiUrl + logo;
        }
        return logo;
       }
        return null;
    },
    appointmentPickupService: () => {
      const active = store.additionalServices().filter(s => s.is_appointment_management && s.state);
      return active.find(s => TransportHelper.isSpecificServiceForPickup(s))
          ?? active.find(s => TransportHelper.isServiceCombined(s))
          ?? null;
    },
    appointmentDeliveryService: () => {
      const active = store.additionalServices().filter(s => s.is_appointment_management && s.state);
      return active.find(s => TransportHelper.isSpecificServiceForDelivery(s))
          ?? active.find(s => TransportHelper.isServiceCombined(s))
          ?? null;
    },
    appointmentCombinedService: () => {
      const active = store.additionalServices().filter(s => s.is_appointment_management && s.state);
      return active.find(s => TransportHelper.isServiceCombined(s)) ?? null;
    },
    appointmentAdditionalService: () => {
      return store.additionalServices().find(s => s.is_appointment_management && s.state) ?? null;
    }
  })),
  // MÃ©todo globales 
  withMethods((store) => {
    
      return {

        updateState: (updates: Partial<ClientsState>) => {
          patchState(store, {...updates} );
          saveClientStoreToStorage(store);
        }, 
        initializeFromStorage: () => {
          var loadedStore = loadClientStoreFromStorage();
          if(loadedStore){
            patchState(store, loadedStore);
          }
        },
        destroy: () => {
         patchState(store, new ClientsState()); 
        }
      }
    }),
    withMethods((store) => {
      const prov = inject(ClientsProvider);
      return {
      
      validGralData: (gral: Partial<ClientDto>) : string[] => {
        const errors: string[] = [];
        store.updateState({errors });
        if(Helpers.isEmpty(gral.name) )                             errors.push('errors.client.name-required');
        if(Helpers.isEmptyOrZero(gral.client_group) )               errors.push('errors.client.group-required');
        if(Helpers.isEmpty(gral.client_type) )                      errors.push('errors.client.client-type-required');
        if(gral.is_subentity && (Helpers.isEmpty(gral.parent) )  )  errors.push('errors.client.principal-client-required');
        if(Helpers.isEmpty(gral.contact_person_email))              errors.push('errors.client.contact-email-invalid');
        if(Helpers.isEmpty(gral.contact_person_name))               errors.push('errors.client.contact-name-required');
        if(Helpers.isEmpty(gral.cif))                               errors.push('errors.client.cif-required');
        if(Helpers.isEmpty(gral.invite_delay_minutes))        errors.push('errors.client.invite-delay-required');
        if(Helpers.isEmpty(gral.reminder_interval_minutes))   errors.push('errors.client.reminder-interval-required');
        
        store.updateState({errors, client: {...store.client(), ...gral}  });
        return errors;
      },

      validateBilling: () : string[] =>{
        const errors: string[] = [];
        store.updateState({errors });
        
        const b = store.currentBillingAccount();
        const hasEmail = !Helpers.isEmpty(b.email_send_invoice) || (Array.isArray(b.emails_send_invoice_array) && b.emails_send_invoice_array.length > 0);
        if(!hasEmail)                                       errors.push('errors.billing.email_send_invoice');
        if(Helpers.isEmpty(b.document_type) )               errors.push('errors.billing.document_type');
        if(Helpers.isEmpty(b.vat) )                         errors.push('errors.billing.iva');
        if(Helpers.isEmpty(b.business_name) )               errors.push('errors.billing.business_name');
        if(Helpers.isEmpty(b.address) )                     errors.push('errors.billing.address');
        if(Helpers.isEmpty(b.postal_code) )                 errors.push('errors.billing.postal_code');
        if(Helpers.isEmpty(b.country) )                     errors.push('errors.billing.country');
        if(Helpers.isEmpty(b.city) )                        errors.push('errors.billing.city');
        if(Helpers.isEmpty(b.phone) )                       errors.push('errors.billing.phone');
        if(Helpers.isEmpty(b.entity_number) )               errors.push('errors.billing.entity_number');

        store.updateState({errors });


        return errors;
      },
          loadById: async  (clientId: number) => {
          try{
            const clientData = await prov.getClientGralData(clientId);
            if(!clientData){
              return;
            }
            store.updateState({client: clientData });
            if(clientData.id && clientData.id > 0){
              // Cargar datos adicionales
              const fullData = await prov.getClientFullData(clientData.id);
              if(fullData){
                store.updateState({ 
                  documents: fullData.documents, 
                  billingsAccounts: fullData.billings, 
                  priceRules: fullData.priceRules, 
                  certifications: fullData.certifications, 
                  certificationsTemplates: fullData.certificationsTemplates,
                  protocols: fullData.protocols,
                  curImage:  null,
                  currentDocument: {} as  DocumentsClientsDto,
                  currentProtocol: new ProtocolDto(),
                  currentCertification: new ClientCertification(),
                  additionalServicesTemplates: fullData.additionalServiceTemplates,
                  additionalServices: fullData.additionalServices,
                  transportAddress: fullData.transportAddress && fullData.transportAddress.length > 0 ? fullData.transportAddress.map(t => new TransportAddress(t)) : [],
                  errors: [],
                });
              }
            }
            return store.client();
          }catch(error){
            console.error('Error al cargar cliente por ID:', error);
            return ;
          }
        },

    }}),

    // Metodos que acceden a providers
    withMethods((store) => {
      const prov = inject(ClientsProvider);
      return {
        clearStore: () =>{
          store.updateState(new ClientsState());
        },

    
        saveGralData: async (client?: Partial<ClientDto>) => {
          try{
            if(!client){
              if(store.validGralData(store.client()).length > 0){
                throw new Error('Datos generales del cliente no son vÃ¡lidos.');
              }
            }
            let savedClient: Partial<ClientDto> | null= client ?? store.client();
            if(!savedClient.is_subentity){
              delete(savedClient.parent);
            }
            let result; 
            let isNew = false;
            if(savedClient.id && savedClient.id > 0){
              result = await prov.updateClientGralData(savedClient, store.curImage());
            }else{
              result = await prov.createClientGralData(savedClient, store.curImage());
              isNew = true;
            }
            if(!result || typeof result === 'string'){
              throw  result;
            }
            store.loadById(result.id);
/*             savedClient = result as ClientDto;

            store.updateState({ client: savedClient as ClientDto, curImage: null });
            if(isNew){
             
            }
            console.log('savedClient', savedClient);
 */          }catch(error){
            console.error('Error al guardar datos generales del cliente:', error);
            throw error;
          }

        },
        saveDocument: async (document: Partial<DocumentsClientsDto>, fileUpload: File | null = null) => {
          try{
            document.client = store.client().id;
            if(Helpers.isEmpty(document.link)) document.link = "";
            if(Helpers.isEmpty(document.title)) document.title ?? fileUpload?.name;
            const {file, ...docData} = document;
            var doc = await prov.createClientDocument(docData, fileUpload);
            if(doc){
              store.updateState({ documents: [...store.documents()!, doc! ], currentDocument: {} as DocumentsClientsDto });
              return doc;
            }
            return null;
          }catch(error){
            console.error('Error al guardar documento del cliente:', error);
            throw error;
          }
        },
        deleteDocument: async (document: Partial<DocumentsClientsDto>) => {
          try{
            var id = document.id;
            var doc = await prov.deleteClientDocument(document);
            if(doc){
              store.updateState({ documents: store.documents().filter(d => d.id!=id)});
              return true;
            }
            return false;
          }catch(error){
            console.error('Error al guardar documento del cliente:', error);
            return false;
          }
        },
        saveBilling: async () => {
          try{
            
            const errors = store.validateBilling();

            if(errors.length > 0){
              return "";
            }

            let {id, ...billing} = store.currentBillingAccount();
            let isNew = false;
            if(Helpers.isEmptyOrZero(id)){
              isNew = true;
            }
            billing.client = store.client().id!;
            delete(billing.deleted_date);
            billing.state = true;
            let result;
            if(id){
              const b =ClientBillingAccountEntity.fromDto(store.currentBillingAccount());
              billing = b.toPatch() as any; 
            }
             result = await prov.updateBilling(billing, id);
             if(typeof result === 'string'){
               throw result;
             }
            if(result){
              var newState: Partial<ClientsState> = { currentBillingAccount: new ClientBillingAccountDto(), errors: [] };
              if(isNew){
                newState = { ...newState, billingsAccounts: [...store.billingsAccounts(), BillingAccountItemDto.fromJson(result)] };
              }else{
                newState = { ...newState, billingsAccounts: [...store.billingsAccounts().filter(b => b.id !== result.id), BillingAccountItemDto.fromJson(result)] };
              }
              store.updateState(newState);
              return result;
            }
            return "";
          }catch(error){
            
            throw error;
          }
        },
        deleteBilling: async (billingId: number) => {
          try {
            await prov.deleteBillingById(billingId);
            store.updateState({ billingsAccounts: store.billingsAccounts().filter(b => b.id !== billingId) });
            return true;
          } catch (error) {
            return null;
          }
        },
        loadBillingById: async (billingId: number): Promise<ClientBillingAccountDto | null> => {
          try {
            var result = await prov.getBillingById(billingId);
            if(result){
              store.updateState({ currentBillingAccount: result });
              return result;
            }
          } catch (error) {
            return null;
          }
          return null;
        },
        updatePrices: async (price: PriceRulesClientDto) => {
          try {
            if(Helpers.isEmptyOrZero(price.client))  price.client = store.client().id!;
            const result = await prov.updatePriceRules(price);
            if(result && !(result instanceof ErrorBase)) {
              store.updateState({ priceRules: result });
              return result;
            }

            return result;
          } catch (error) {
            return error;
          }
        },
        setCurrentProtocol: (protocol?: ProtocolDto) => {
          if(!protocol){
            store.updateState({ currentProtocol: new ProtocolDto() });
            return;
          }
          if(protocol.is_template){
            var {id, ...rest} = protocol;
            store.updateState({ currentProtocol: rest });
            return;
          }else{
            store.updateState({ currentProtocol: protocol });
          }
        },
        saveCurrentProtocol: async (protocol: ProtocolDto) => {
          try {
            
              // Crear nuevo
              let protocolToSave = { ...protocol, client: store.client().id! };
              protocolToSave.is_template = false; 
              protocolToSave.transport = null;
              protocolToSave.options = protocolToSave.options?.map(opt => {
                delete(opt.id);
                return opt;
              });
              const result = await prov.updateProtocol(protocolToSave);
              if(result && !(result instanceof ErrorBase)) {
                // Actualizar lista
                let updatedProtocols = store.protocols().filter(p => p.id !== result.id);
                updatedProtocols.push(result);
                store.updateState({ protocols: updatedProtocols, currentProtocol: new ProtocolDto() });
                
              }
              return result;

          } catch (error) {
            return error;
          }           
        },
        deleteProtocol: async (protocolId: number) => {
          try {
            var result = await prov.deleteProtocolById(protocolId);
            if(result){
              store.updateState({ protocols: store.protocols().filter(p => p.id !== protocolId) });
              return true;
            }
            return false;
          } catch (error) {
            return false;
          }
        },

        saveCertification: async (certification: ClientCertification) => {
          try {
            const result = await prov.updateCertification(certification);
            if(result && !(result instanceof ErrorBase)) {
                // Actualizar lista
                let updatedCertifications = store.certifications().filter(p => p.id !== result.id);
                updatedCertifications.push(result);
                store.updateState({ certifications: updatedCertifications, currentCertification: new ClientCertification() });
            }
            return result;
          } catch (error) {
            return error;             
          }
        },
        deleteCertification: async (certificationId: number) => {
          try {
            var result = await prov.deleteCertificationById(certificationId);
            if(result){
              store.updateState({ certifications: store.certifications().filter(p => p.id !== certificationId) });
              return true;
            }
            return false;
          } catch (error) {
            return false;
          }
        },

        saveAdditionalService: async (additionalServices: ClientAdditionalServiceDto) => {
          try {
            const result = await prov.updateAdditionalServices(additionalServices.toUpdate(), additionalServices.id);
            if(result && !(result instanceof ErrorBase)) {
                // Actualizar lista
                let updatedCertifications = store.additionalServices().filter(p => p.id !== result.id);
                updatedCertifications.push(result as ClientAdditionalServiceDto);
                store.updateState({ additionalServices: updatedCertifications, currentAdditionalService: new ClientAdditionalServiceDto() });
            }else{
              return "";
            }
            return result;
          } catch (error) {
             throw error;
          }
        },
        refreshTransport: async () => {
          try {
            if(store.client().id && store.client().id > 0){
              const transportAddress = await prov.getTransportAddressesByClient(store.client().id);
              store.updateState({ transportAddress: transportAddress.map(t => new TransportAddress(t)) });
            }
          } catch (error) {
             throw error;
          }
        }
        
    }}),
    withMethods((store) => {
      const prov = inject(ClientsProvider);
      return {
        deleteClient: async (clientId: number): Promise<boolean> => {
          try{
            var result = await prov.deleteClientById(clientId);
            
            return true;
          }
          catch(error){
            console.error('Error al eliminar cliente:', error);
            return false;
          } 
        }

      }
    })





  );
  


function saveClientStoreToStorage(store: any, key = 'roadit_client_store') {
  const result: Record<string, unknown> = {};
  for (const prop of Object.keys(new ClientsState())) {
    result[prop] = store[prop]();
  }
  Helpers.setSessionStorage(key, result);
}

// Restaura solo las claves de GlobalStateData, asumiendo que todas son signals
function loadClientStoreFromStorage( key = 'roadit_client_store'): ClientsState | null {
  
  return Helpers.getSessionStorage<ClientsState>(key);
}
